class LocationHistoryService {

    constructor() {
        this.className = 'LocationHistoryService'
        this.locationHistory = []
    }

    hasLocationHistory(){
        return this.locationHistory.length > 0
    }

    setLocationHistory(locationHistory) {
        this.locationHistory = locationHistory
    }

    sortLocationHistory(location) {
        this.locationHistory.sort(function (x, y) {
            return x.address == location.address ? -1 : y.address == location.address ? 1 : 0;
        })
    }

    hasAddress(address) {
        return this.locationHistory.some(lh => lh.address === address)
    }

    addLocationHistory(location) {
        if (location && location.address != '' && location.latitude != null && location.longitude != null) {
            if (!this.hasAddress(location.address)) {
                this.locationHistory.push(Object.assign({}, location))
            }
            this.sortLocationHistory(location)
        }
    }

    removeLocationHistory(location) {
        let index = this.locationHistory.findIndex(lh => lh.address === location.address)
        if (index != -1) {
            this.locationHistory.splice(index, 1)
        }
    }
}

export default LocationHistoryService;
